import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { useStyles } from './Payment.styled';
import { Box, Typography, Button } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export const PaymentNumberStripe = ({ data }) => {
  const classes = useStyles();
  const paymentType = data?.payment_type || data?.type;
  const hasHostedUrl = data?.hosted_verification_url;
  const isVerifying =
    data?.status === 'processing' ||
    data?.status === 'verifying' ||
    (paymentType === 'ach' && data?.status === 'NEW' && !hasHostedUrl);
  const showVerify = paymentType === 'ach' && data?.status === 'NEW' && hasHostedUrl;
  const isFailed = data?.status === 'FAILED';
  const paymentExp =
    data?.exp_month && data?.exp_year
      ? `${String(data?.exp_month).padStart(2, '0')}/${data?.exp_year?.toString()?.substr(-2)}`
      : '';

  return (
    <Typography>
      <Box fontSize={13} component="span" fontWeight="medium" className={classes.paymentNumber}>
        **** **** {data?.last_four}
        <span style={{ marginLeft: '0.5rem', fontWeight: 'normal' }}>
          {paymentExp ? `  ${paymentExp}` : ''}
        </span>
        {isVerifying && (
          <Typography variant="caption" sx={{ color: '#FF9800', fontWeight: 'bold', ml: 1 }}>
            {i18n.t('organization.verifying')}
          </Typography>
        )}
        {isFailed && (
          <Typography variant="caption" sx={{ color: '#F44336', fontWeight: 'bold', ml: 1 }}>
            {i18n.t('payment_method.failed')}
          </Typography>
        )}
        {showVerify ? (
          <Button
            className={classes.verifyButton}
            component="a"
            href={data?.hosted_verification_url}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            sx={{ ml: 1 }}
          >
            {i18n.t('organization.verify_account')}
          </Button>
        ) : null}
      </Box>
    </Typography>
  );
};

PaymentNumberStripe.propTypes = {
  data: PropTypes.shape({
    payment_type: PropTypes.string,
    type: PropTypes.string,
    last_four: PropTypes.string,
    exp_month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    exp_year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
    hosted_verification_url: PropTypes.string,
  }),
};

export const PaymentIconStripe = ({ type }) => {
  switch (type) {
    case 'credit_card':
      return <CreditCardIcon />;
    case 'ach':
    case 'bank_account':
      return <AccountBalanceIcon />;
    default:
      return <CreditCardIcon />;
  }
};

PaymentIconStripe.propTypes = {
  type: PropTypes.string,
};
